var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1073,
    height: 872,
    viewBox: "0 0 1073 872",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18,
    filter: "url(#filter0_f_78_822)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-6.25273 -118.2C68.1608 -180.647 176.603 -129.377 273.687 -132.214C374.464 -135.159 477.302 -185.246 564.619 -134.882C670.994 -73.5259 789.678 32.7657 769.889 153.992C750.135 275.005 577.711 283.382 483.524 361.913C407.641 425.184 376.812 540.225 280.468 562.066C169.212 587.287 37.7798 565.141 -38.3468 480.22C-112.361 397.655 -83.5659 273.351 -77.6263 162.603C-72.2499 62.3557 -83.1665 -53.6552 -6.25273 -118.2Z",
    fill: "#FF4800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_78_822",
    x: -388.103,
    y: -457.229,
    width: 1460.17,
    height: 1329.09,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_78_822"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundClear);
export default __webpack_public_path__ + "static/media/backgroundClear.a4ac72cf01b10abc39441e7c43bab155.svg";
export { ForwardRef as ReactComponent };